import { useCallback, useEffect, useState } from 'react';

import apiToken from '@/shared/services/axiosInstance';

import { SearchResult } from '../types/SearchTypes';

export const useSearch = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState<SearchResult[]>([]);

  const getSearchResults = useCallback(async () => {
    // Skip API call if searchTerm is empty or only whitespace
    const trimmedSearchTerm = searchTerm.trim();
    if (!trimmedSearchTerm) {
      setSearchResults([]);
      return;
    }

    try {
      const response = await apiToken.get(
        `/api/v1/product/search?page=1&limit=4&sort=latest&stockStatus=all&keyword=${trimmedSearchTerm}`,
      );
      setSearchResults(response.data.data.productOptionList);
    } catch (error) {
      setSearchResults([]);
    }
  }, [searchTerm]);

  useEffect(() => {
    if (searchTerm.length > 0) {
      const debounceTimer = setTimeout(() => {
        getSearchResults();
      }, 300);

      return () => clearTimeout(debounceTimer);
    }
    setSearchResults([]);
    return undefined;
  }, [searchTerm, getSearchResults]);
  const trimmedSearchTerm = searchTerm.trim();

  return { searchTerm, setSearchTerm, searchResults, trimmedSearchTerm };
};
